import { EntityResolutionCardView } from '@/components/case-overview/EntityResolutionCardView'
import { useEntityResolutionCount } from '@/features/case-overview/useEntityResolutionCount'

/**
 * Connected entity-resolution callout for the case overview. Fetches the
 * pending-match count and feeds the pure {@link EntityResolutionCardView}.
 */
export function EntityResolutionCard({ caseId }: { caseId: string }) {
  const { pending, isLoading, isError } = useEntityResolutionCount(caseId)
  return (
    <EntityResolutionCardView
      pending={pending}
      isLoading={isLoading}
      isError={isError}
      linkTo={`/cases/${caseId}/entity-resolution`}
    />
  )
}
